export const FOOTER_HEIGHT = 90

export const NO_OF_STORIES_TO_FETCH = 10